// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'tasks'

/**
 * Task Model Interface (auto-generated from Drizzle schema)
 */
export interface TaskModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name?: string
  title: string
  description?: string
  dueAt?: string
  startAt?: string
  startedAt?: string
  completedAt?: string
  status: string
  type?: string
  completed?: boolean
  projectId: string
  milestoneId: string
  parentTaskId: string
  archived: boolean
  timeBudgetHours?: number
  isRecurring?: boolean
  recurrenceRule?: string
  parentRecurrenceId?: string
  recurrenceInstanceDate?: string
  categoryId?: string
  tagIds?: string[]
  priority: number
  assigneeId: string
  estimatePoints?: number
  sortOrder: number
  version: number
  mentions?: unknown[]
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    orgId: {
      type: 'string',
      maxLength: 100,
    },
    workspaceId: {
      type: 'string',
      maxLength: 100,
    },
    userId: {
      type: 'string',
      maxLength: 100,
    },
    createdAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    metadata: {
      type: 'object',
    },
    extended: {
      type: 'object',
    },
    name: {
      type: 'string',
      maxLength: 500,
    },
    title: {
      type: 'string',
      maxLength: 500,
    },
    description: {
      type: 'string',
      maxLength: 100000,
    },
    dueAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    startAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    startedAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    completedAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    status: {
      type: 'string',
      maxLength: 50,
      default: 'todo',
    },
    type: {
      type: 'string',
      maxLength: 200,
    },
    completed: {
      type: 'boolean',
    },
    projectId: {
      type: 'string',
      maxLength: 100,
    },
    milestoneId: {
      type: 'string',
      maxLength: 100,
    },
    parentTaskId: {
      type: 'string',
      maxLength: 100,
    },
    archived: {
      type: 'boolean',
    },
    timeBudgetHours: {
      type: 'number',
    },
    isRecurring: {
      type: 'boolean',
    },
    recurrenceRule: {
      type: 'string',
      maxLength: 200,
    },
    parentRecurrenceId: {
      type: 'string',
      maxLength: 100,
    },
    recurrenceInstanceDate: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    categoryId: {
      type: 'string',
      maxLength: 100,
    },
    tagIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    priority: {
      type: 'integer',
      minimum: 0,
      maximum: 4,
      multipleOf: 1,
    },
    assigneeId: {
      type: 'string',
      maxLength: 100,
    },
    estimatePoints: {
      type: 'number',
      minimum: 0,
      maximum: 10000,
      multipleOf: 0.5,
    },
    sortOrder: {
      type: 'integer',
      minimum: 0,
      maximum: 999999,
      multipleOf: 1,
    },
    version: {
      type: 'integer',
      minimum: 1,
      maximum: 9999999,
      multipleOf: 1,
    },
    mentions: {
      type: 'array',
      items: {},
    },
    tenantId: {
      type: 'string',
      maxLength: 100,
    },
  },
  required: [
    'id',
    'orgId',
    'createdAt',
    'updatedAt',
    'title',
    'archived',
    'version',
    'workspaceId',
    'projectId',
    'milestoneId',
    'parentTaskId',
    'assigneeId',
    'status',
    'priority',
    'sortOrder',
  ],
  indexes: [
    ['orgId', 'createdAt'],
    ['workspaceId', 'createdAt'],
    ['projectId', 'createdAt'],
    ['milestoneId', 'createdAt'],
    ['parentTaskId', 'createdAt'],
    ['orgId', 'assigneeId', 'createdAt'],
    ['orgId', 'status', 'priority'],
    ['milestoneId', 'sortOrder'],
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
